import { useMutation } from 'react-query';

import { createPoapView as mutationFn } from 'api/endPoints/createPoapView';

export const useMutationCreatePoapView = () => {
    return useMutation<CreatePoapViewResponse, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface CreatePoapViewResponse {
    viewName: string;
    viewId: number;
}

export interface QueryParams {
    viewName: string;
    viewOrder?: number;
}
